import VariacaoItemService from "@/services/VariacaoItemService";

export const variacaoItem = {
  namespaced: true,
  state: {
    variacaoItem: {},
  },
  actions: {
    getVariacaoItem({ commit }, payload) {
      return VariacaoItemService.GetVariacaoItem(payload).then(
        (variacaoItem) => {
          return Promise.resolve(variacaoItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postVariacaoItem({ commit }, payload) {
      return VariacaoItemService.PostVariacaoItem(payload).then(
        (variacaoItem) => {
          return Promise.resolve(variacaoItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putVariacaoItem({ commit }, payload) {
      return VariacaoItemService.PutVariacaoItem(payload).then(
        (variacaoItem) => {
          return Promise.resolve(variacaoItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteVariacaoItem({ commit }, payload) {
      return VariacaoItemService.DeleteVariacaoItem(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getVariacaoItemOData({ commit }, payload) {
      return VariacaoItemService.GetVariacaoItemOData(payload).then(
        (variacaoItem) => {
          return Promise.resolve(variacaoItem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default variacaoItem;
